import React from 'react';
import { Box, Button, Stack, Typography } from '@mui/material';
import { useAppDispatch } from '../../../../support/store';
import { JourneyMapDraftLink } from '../../../../types/journeyMap';
import {
  removeJourneyMapDraftLink,
  updateJourneyMapDraftLink,
} from '../../../../support/slices/journeyMapBuilderSlice';
import JourneyMapRule from '../JourneyMapRule';

type Props = {
  link: JourneyMapDraftLink;
};

const JourneyMapSidePanelLinkEditor: React.FC<Props> = ({ link }) => {
  const dispatch = useAppDispatch();

  return (
    <Box sx={{ p: 2 }}>
      <Stack spacing={2}>
        <Typography variant="subtitle2" sx={{ fontWeight: 700 }}>
          Link
        </Typography>

        <JourneyMapRule
          link={link}
          onChange={(changes) =>
            dispatch(
              updateJourneyMapDraftLink({
                tempId: link.tempId,
                changes,
              }),
            )
          }
        />

        <Button
          color="error"
          variant="contained"
          onClick={() => dispatch(removeJourneyMapDraftLink(link.tempId))}
        >
          Delete Link
        </Button>
      </Stack>
    </Box>
  );
};

export default JourneyMapSidePanelLinkEditor;